import { DeviceInfo } from "@/interface/deviceInfo";
import { DiagnosticDetailInterface } from "@/redux/slice/diagnostics/types/fetchDiagnosticsPayload";
import { DoctorDetails } from "@/redux/slice/doctors/types/FetchDoctorsPayload";

export type RefsObjectType = { [key: string]: HTMLElement };

export type RegisterRefType = (key: string, element: HTMLElement) => void;

export type DeregisterRefType = (key: string) => void;

export interface serverReturnType {
  ua: DeviceInfo;
  referer?: string;
  userOnBoarded: boolean;
  homeData: any;
  currentSpeciality?: string;
  doctorsArray?: DoctorDetails[];
  diagnosticsArray?: DiagnosticDetailInterface[];
}

export enum CategoryIconType {
  "Pregnancy" = "pregnancy",
  "Preconception" = "preconception",
  "Postpartum" = "birth",
  "New born & Infant" = "newMom",
}

export enum STYLE_TYPE {
  STYLE1 = "style1",
  STYLE2 = "style2",
  STYLE3 = "style3",
  STYLE4 = "style4",
}
